import React from 'react';
import { team } from '../mock';

const scrollToContact = () => {
  const element = document.getElementById('contacto');
  if (element) {
    const offset = 130;
    const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }
};

const TeamSection = () => {
  return (
    <section id="equipo" className="py-32 bg-white">
      <div className="container mx-auto px-6 sm:px-12 lg:px-20">
        {team.map((member) => (
          <div key={member.id} className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-stretch">
            {/* Content Side (left) */}
            <div className="flex flex-col justify-center order-2 lg:order-1">
              <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-700 mb-6">
                Nuestro Equipo
              </p>
              <h2 className="text-4xl sm:text-5xl font-serif font-light text-gray-900 mb-3">
                {member.name}
              </h2>
              <p className="text-sm uppercase tracking-[0.2em] text-sage-700 mb-8">
                {member.title}
              </p>
              <p className="text-lg text-gray-700 leading-relaxed font-light mb-10">
                {member.description}
              </p>

              {/* Expertise list */}
              <div className="border-t border-[#E6E4DD] mb-10">
                {member.expertise.map((item) => (
                  <div
                    key={item}
                    className="py-3 border-b border-[#E6E4DD] text-gray-700 font-light text-sm flex items-center gap-4"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-gold-600 flex-shrink-0"></span>
                    {item}
                  </div>
                ))}
              </div>

              <div>
                <button
                  onClick={scrollToContact}
                  data-testid="team-cta-button"
                  className="inline-flex items-center px-10 py-4 bg-[#6E4F35] hover:bg-[#5a3f2a] text-cream-100 text-sm font-medium uppercase tracking-[0.15em] transition-colors duration-300"
                >
                  Agendar Consulta
                </button>
              </div>
            </div>

            {/* Portrait Side (right) */}
            <div className="relative order-1 lg:order-2 min-h-[480px] lg:min-h-0">
              <img
                src={member.image}
                alt={member.name}
                className="absolute inset-0 w-full h-full object-cover"
                style={{ objectPosition: 'center 20%' }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TeamSection;
